// extracted by mini-css-extract-plugin
module.exports = {"photoDetail":"detail_photoDetail__3MMr9","photos":"detail_photos__1j2ss","photo":"detail_photo__JeOur"};